import CloseIcon from "@mui/icons-material/Close";
import SaveIcon from "@mui/icons-material/Save";
import AddCircleOutlineIcon from "@mui/icons-material/AddCircleOutline";
import RemoveCircleOutlineIcon from "@mui/icons-material/RemoveCircleOutline";
import MDBox from "components/MDBox";
import { StyledEngineProvider } from "@mui/material/styles";
import "./crud.css";
import "global-styles/progressBar.css";
import MDButton from "components/MDButton";
import React, { useState, useEffect } from "react";
import {
  Button,
  Dialog,
  DialogContent,
  DialogTitle,
  IconButton,
  LinearProgress,
  TextField,
  Typography,
  Switch,
  Autocomplete,
  Tooltip,
} from "@mui/material";
import FormGroup from "@mui/material/FormGroup";
import FormControlLabel from "@mui/material/FormControlLabel";
import FueroService from "services/Fuero";
import TipoExclusionService from "services/Tipo-Exclusion";
import FueroExclusionService from "services/Fuero-Exclusion";

// eslint-disable-next-line react/prop-types
function Crud({
  setDisplayDialogParent,
  setMessage,
  setShowMessage,
  crudAction,
  crudData,
  updateTableRow,
}) {
  const descripcionFuero = crudData.data.descripcion_fuero;
  const descripcionTipoExclusion = crudData.data.descripcion_tipo_exclusion;
  const idFueroExclusion = crudData.data.id || "";
  const idFuero = crudData.data.id_fuero || null;
  const idTipoExclusion = crudData.data.id_tipo_exclusion || "";
  const [observacionesFueroExclusion, setObservacionesOficinaMateria] = useState(
    crudData.data.observaciones || ""
  );

  const [loading, setLoading] = useState(false);
  const [isHabilitado, setIsHabilitado] = React.useState(crudData.data.habilitado || false);
  const [triggerDeshabilitarConfirmation, setTriggerDeshabilitarConfirmation] = useState(false);
  const [tiposExclusiones, setTiposExclusiones] = useState([]);
  const [fueros, setFueros] = useState([]);
  const [selectedFuero, setSelectedFuero] = useState(null); //set to null for autocomplete to load empty val if no val is selected or found
  const [selectedTipoExclusion, setSelectedTipoExclusion] = useState(null);
  const [buttonGuardarOk, setButtonGuardarOk] = useState(false);

useEffect( () => {
handleButtonGuardar(); 
return () => {
handleButtonGuardar(setButtonGuardarOk(false));
};
}, [selectedTipoExclusion, observacionesFueroExclusion, selectedFuero])

function handleButtonGuardar(){
setButtonGuardarOk(false);
if((selectedTipoExclusion === null || selectedFuero === null) ){
setButtonGuardarOk(false) 
}else if(selectedTipoExclusion.id !== crudData.data.id_tipo_exclusion || observacionesFueroExclusion !== crudData.data.observaciones || selectedFuero.id !== crudData.data.id_fuero ){
setButtonGuardarOk(true)
}
}

  const loadTipoExclusion = () => {
    TipoExclusionService.getTipoExclusion({})

      .then((response) => {
        //console.log("what do i have here");
        //console.log(response.data);
        setTiposExclusiones(response.data);
        // setting the already existing value in case of edit action
        setSelectedTipoExclusion(
          response.data.find((tipoExclusion) => tipoExclusion.id === idTipoExclusion) ||
            selectedTipoExclusion
        );
      })
      .catch((e) => {
        //console.log(e);
      });
  };
  useEffect(() => {
    //console.log("crudData.data");
    //console.log(crudData.data);
    //console.log(idFuero);
    FueroService.getFuero({}).then((response) => {
      console.log(response.data)
      setFueros(response.data);
      setSelectedFuero(response.data.find((f) => f.id === idFuero) || selectedFuero);
    });
    if (idTipoExclusion !== "") {
      loadTipoExclusion();
    }
  }, []);

  function updateModifiedValues(row, action) {
    crudData.data.id_fuero = row.id_fuero;
    crudData.data.id_materia = row.id_materia;
    crudData.data.id_usuario = row.id_usuario;
    crudData.data.observaciones = row.id.observaciones;
    crudData.data.id = row.id;
    crudData.data.habilitado = action === "delete" ? !isHabilitado : isHabilitado;
    //inquiry about what to show when its disabled/deleted./

    return crudData.data;
  }

  const handleObservacionesOficinaMateria = (e) => {
    setObservacionesOficinaMateria(e.target.value);
  };

  const handleChange = (event) => {
    setChecked(event.target.checked);
  };

  const handleNombreMateria = (e) => {
    setNombreMateria(e.target.value);
  };

  const newFueroExclusionHandler = () => {
    // setLoading(true);
    //console.log("created OK");
    FueroExclusionService.createFueroExclusion({
      id_fuero: selectedFuero.id,
      id_tipo_exclusion: selectedTipoExclusion.id,
      observaciones: observacionesFueroExclusion,
    })
      .then((response) => {
        //console.log("*****************************");
        //console.log(response);
        //console.log("*****************************");
        if (response.error) {
          setMessage({
            severity: "error",
            messageText: response.data.human_message,
          });
          setShowMessage(true);
          return;
        }
        setMessage({
          severity: "success",
          messageText: "Fuero Tipo Exclusion creado correctamente",
        });
        setShowMessage(true);
        setDisplayDialogParent(false);
      })
      .catch((e) => {
        // setLoading(false);
        //console.log(e);
      });
  };

  const updateFueroExclusionHandler = () => {
    // setLoading(true);
    const updateObj = {
      id_fuero: selectedFuero.id,
      id_tipo_exclusion: selectedTipoExclusion.id,
      observaciones: observacionesFueroExclusion,
      id: idFueroExclusion,
    };
    console.log(JSON.stringify(updateObj))
    FueroExclusionService.updateFueroExclusion(updateObj)
      .then((response) => {
        if (response.error) {
          setMessage({
            severity: "error",
            messageText: response.human_message,
          });
          setShowMessage(true);
          setButtonGuardarOk(false);
          setLoading(false);
          return;
        }
        //console.log("updated OK");
        //console.log(response);
        setMessage({
          severity: "success",
          messageText: "Fuero-Tipo de Exclusión actualizado correctamente",
        });
        setShowMessage(true);
        setDisplayDialogParent(false);
        updateTableRow(updateModifiedValues(updateObj, "update"));
      })
      .catch((e) => {
        // setLoading(false);
        //console.log(e);
      });
  };

  // const deleteMateriaHandler = () => {
  //   // setLoading(true);
  //   FueroExclusionService.deleteFueroExclusion({
  //     action: isHabilitado ? "disable" : "enable",
  //     id: idFueroExclusion,
  //   })
  //     .then((response) => {
  //       //console.log("disabled OK");
  //       //console.log(response);
  //       setMessage({
  //         severity: "success",
  //       messageText: isHabilitado ? "Fuero-Tipo de Exclusión deshabilitado" : "Fuero-Tipo de Exclusión habilitado",
  //       });
  //       setShowMessage(true);
  //       setDisplayDialogParent(false);
  //       updateTableRow(updateModifiedValues(crudData.data, "delete"));
  //     })
  //     .catch((e) => {
  //       // setLoading(false);
  //       //console.log(e);
  //     });
  // };

  const handleClose = () => {
    // eslint-disable-next-line react/prop-types
    setDisplayDialogParent(false);
  };

  return (
    // <StyledEngineProvider injectFirst>
    //   <Dialog open onClose={handleClose}>
    //     <DialogTitle id="form-dialog-title">
    //       {crudAction === "create"
    //         ? "Nuevo Fuero-Tipo de Exclusion"
    //         : crudAction === "readonly"
    //         ? "Información de Fuero-Tipo de Exclusion"
    //         : "Editar Fuero-Tipo de Exclusion"}
    //       <IconButton
    //         aria-label="close"
    //         onClick={handleClose}
    //         sx={{
    //           position: "absolute",
    //           right: 8,
    //           top: 8,
    //           color: (theme) => theme.palette.grey[500],
    //         }}
    //       >
    //         <CloseIcon />
    //       </IconButton>
    //     </DialogTitle>

    //     <DialogContent dividers>
    <>
          {!triggerDeshabilitarConfirmation && (
            <>
              {/* {crudAction !== "create" && crudAction !== "readonly" && (
                <div className="botonDeshabilitar">
                  <MDButton
                    size="small"
                    color={isHabilitado ? "error" : "success"}
                    variant="contained"
                    startIcon={<SaveIcon />}
                    onClick={() => {
                      setTriggerDeshabilitarConfirmation(true);
                    }}
                  >
                    {isHabilitado ? "Deshabilitar" : "Habilitar"}
                  </MDButton>
                </div>
              )} */}
              <div className="containercrud">
                {loading && <LinearProgress color="primary" className="progressBar" />}

                {(crudAction === "create" || crudAction === "update") && (
                  <div>
                    <Autocomplete
                      disableClearable
                      id="combo-box-demo"
                      options={fueros.filter((item)=>item.habilitado==true)}
                      value={selectedFuero} // selectedFuero starts as null and then gets the value from the autocomplete
                      sx={{ width: 350, marginBottom: "15px" }}
                      getOptionLabel={(option) => option.descripcion}
                      renderInput={(params) => <TextField {...params} label="Fuero" />}
                      onChange={(event, newValue) => {
                        console.log(selectedFuero)
                        console.log(newValue);
                        setSelectedFuero(newValue);
                        loadTipoExclusion(newValue.id);
                      }}
                    />

                    <Autocomplete
                      disableClearable
                      id="combo-box-demo"
                      options={tiposExclusiones.filter((item)=>item.habilitado==true)}
                      value={selectedTipoExclusion}
                      sx={{ width: 350, marginBottom: "15px" }}
                      getOptionLabel={(option) => option.descripcion}
                      renderInput={(params) => <TextField {...params} label="Tipo de Exclusion" />}
                      onChange={(event, newValue) => {
                        setSelectedTipoExclusion(newValue);
                      }}
                    />
                  </div>
                )}
                <div className="observacionescrud">
                  <TextField
                    id="observaciones"
                    variant="outlined"
                    size="small"
                    name="observaciones"
                    label="Observaciones Fuero-Tipo de Exclusión"
                    sx={{ width: "100%", pb: 2 }}
                    disabled={crudAction === "readonly"}
                    multiline
                    rows={5}
                    value={observacionesFueroExclusion}
                    onChange={handleObservacionesOficinaMateria}
                  />
                </div>
                {/* {crudAction === "readonly" && (
                  <div className="observacionescrud">
                    <TextField
                      id="observaciones_fuero"
                      variant="outlined"
                      size="small"
                      name="observaciones"
                      label="Observaciones Fuero"
                      sx={{ width: "100%", pb: 2 }}
                      disabled={crudAction === "readonly"}
                      multiline
                      rows={5}
                      value={observacionesFueroExclusion}
                    />
                  </div>
                )} */}

                {/* reeplace this for a filter and exclude the disabled ones */}

                <div className="botonesaccionescrud">
                  <MDButton
                    sx={{ marginRight: "5px" }}
                    size="small"
                    color="secondary"
                    onClick={handleClose}
                    variant="contained"
                    startIcon={<SaveIcon />}
                  >
                    Cancelar
                  </MDButton>
                  <Tooltip title={ !buttonGuardarOk ? "No ha realizado ningún cambio en los datos" : ""}>
                    <span>
                    <MDButton
                      disabled={!buttonGuardarOk || crudAction == 'readonly'}
                      onClick={
                        crudAction === "create"
                          ? newFueroExclusionHandler
                          : updateFueroExclusionHandler
                      }
                      size="small"
                      color="primary"
                      variant="contained"
                      startIcon={<SaveIcon />}
                    >
                    Guardar
                  </MDButton>
                  </span>
                  </Tooltip>
                </div>
              </div>
            </>
          )}

          {/* {triggerDeshabilitarConfirmation && (
            <div className="containercrud">
              <div className="nombrecrud">
                <Typography
                  variant="h8"
                  component="div"
                  gutterBottom
                  color={isHabilitado ? "red" : "green"}
                >
                  {isHabilitado
                    ? "¿Está seguro que desea deshabilitar el Fuero-Tipo de Exclusión?"
                    : "¿Está seguro que desea habilitar el Fuero-Tipo de Exclusión?"}
                </Typography>
              </div>
              <div className="fueroName">
                <Typography variant="h8" component="div" gutterBottom>
                  {`${descripcionFuero} - ${descripcionTipoExclusion}`}
                </Typography>
              </div>
              <div className="botonesaccionescrud">
                <MDButton
                  sx={{ marginRight: "5px" }}
                  size="small"
                  color="secondary"
                  onClick={() => {
                    setTriggerDeshabilitarConfirmation(false);
                  }}
                  variant="contained"
                  startIcon={<SaveIcon />}
                >
                  Cancelar
                </MDButton>
                <MDButton
                  onClick={deleteMateriaHandler}
                  size="small"
                  color="primary"
                  variant="contained"
                  startIcon={<SaveIcon />}
                >
                  Confirmar
                </MDButton>
              </div>
            </div>
          )} */}

          {/* {true && (
            <MDBox
              sx={{
                p: 1,
                color: "SlateGrey",
                border: "1px solid DarkGray",
                borderRadius: "3px",
              }}
            >
              <Typography variant="h8" component="div" gutterBottom>
                Creado:
              </Typography>

              <Typography variant="h8" component="div" gutterBottom>
                Última actualizacion:
              </Typography>

              <Typography variant="h8" component="div" gutterBottom>
                Último usuario que actualizó:
              </Typography>
            </MDBox>
          )} */}
          </>
    //     </DialogContent>
    //   </Dialog>
    // </StyledEngineProvider>
  );
}

export default Crud;
